import React from 'react';
import './Contact-Us.css';

export default function ContactUs() {
  const EMAIL = 'contact@deimd.com';
  const PHONE_DISPLAY = '(410) 356-1095';
  const PHONE_TEL = '+14103561095';
  const ADDRESS_1 = '10902 Reisterstown Rd #204';
  const ADDRESS_2 = 'Owings Mills, MD 21117';

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);

    const name = (data.get('name') || '').toString().trim();
    const email = (data.get('email') || '').toString().trim();
    const phone = (data.get('phone') || '').toString().trim();
    const message = (data.get('message') || '').toString().trim();

    const subject = `Website Contact: ${name || 'Inquiry'}`;
    const bodyLines = [
      `Name: ${name || '—'}`,
      `Email: ${email || '—'}`,
      `Phone: ${phone || '—'}`,
      '',
      'Message:',
      message || '—',
    ];
    const body = bodyLines.join('\n');

    const mailto = `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailto;
  };

  return (
    <main className="contact-page">
      <header className="contact-hero">
        <h1>Contact Us</h1>
      </header>

      <section className="contact-grid">
        <article className="contact-card">
          <h2>Call</h2>
          <a className="contact-link" href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>
        </article>

        <article className="contact-card">
          <h2>Email</h2>
          <a className="contact-link" href={`mailto:${EMAIL}`}>{EMAIL}</a>
        </article>

        <article className="contact-card">
          <h2>Visit</h2>
          <address>
            {ADDRESS_1}<br />
            {ADDRESS_2}
          </address>
        </article>
      </section>

      <section className="contact-form-wrap">
        <h2>Send us a message</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            name="name"
            type="text"
            placeholder="Your name"
            aria-label="Your name"
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Your email"
            aria-label="Your email"
            required
          />
          <input
            name="phone"
            type="tel"
            placeholder="Your phone (optional)"
            aria-label="Your phone"
          />
          <textarea
            name="message"
            rows="6"
            placeholder="How can we help?"
            aria-label="Your message"
            required
          />

          <button type="submit">Send message</button>
        </form>

      
      </section>
    </main>
  );
}
